import device from "./device";
import inspect from "./inspect";
import other from "./other";
import push from "./push";
import sys from "./sys";
import safety from "./safety";
import order from "./order";
import weather from "./weather";
import linkage from "./linkage";
import ota from "./ota";
import datav from "./datav";
import planePosition from "./planePosition";
import prospect from "./prospect";
import grid from "./grid";
import user from "./user";
import report from "./report";
import sso from "./sso";
import snapshot from "./snapshot";
import enterprise from "./enterprise";

/**
 * 这里包含了所有接口
 */
export default {
  device,
  inspect,
  other,
  push,
  sys,
  order,
  weather,
  linkage,
  ota,
  datav,
  planePosition,
  safety,
  prospect,
  grid,
  report,
  user,
  sso,
  snapshot,
  enterprise,
};
